import { createContext } from 'react';
import { Id } from '../../../Util/Id/Id';

const ExpansionPanelIdContext = createContext<Id>(undefined);

export default ExpansionPanelIdContext;